<script lang="ts">
  export let jsonLD: any;
  let jsonLDString = `<script type="application/ld+json">${JSON.stringify(jsonLD)}<\/script>`;
</script>

<svelte:head>
    {@html jsonLDString}
</svelte:head>